import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_pets_new_brands: FaireCategoryEntity = {
  token: "cat_pets-new-brands",
  type: "category",
  name: "New brands",
  level: 2,
  parentToken: "cat_pets",
  href: "/category/pets/new-brands",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
